"use client";

import { Truck } from "@/components/icons";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { cn } from "@/lib/utils";
import { isTruckTypeSlug, type TruckTypeSlug } from "@/lib/truck-types";
import type { EnabledTruck } from "./recycle-truck-capacities";

interface RecycleTruckTypeFieldProps {
  enabledTrucks: EnabledTruck[];
  value: TruckTypeSlug | undefined;
  onChange: (value: TruckTypeSlug) => void;
}

export function RecycleTruckTypeField({
  enabledTrucks,
  value,
  onChange,
}: RecycleTruckTypeFieldProps) {
  if (enabledTrucks.length === 0) return null;

  return (
    <fieldset className="space-y-1.5">
      <legend className="text-xs font-medium text-foreground">
        Truck type
      </legend>
      <RadioGroup
        value={value ?? ""}
        onValueChange={(next) => {
          if (isTruckTypeSlug(next)) onChange(next);
        }}
        className="grid grid-cols-2 gap-2"
      >
        {enabledTrucks.map((truck) => (
          <label
            key={truck.slug}
            className={cn(
              "flex cursor-pointer items-center gap-2 rounded-md border px-3 py-2 text-xs transition-colors",
              value === truck.slug
                ? "border-primary bg-action-tint"
                : "border-border hover:border-muted-foreground/50",
            )}
          >
            <RadioGroupItem value={truck.slug} />
            <Truck className="h-3.5 w-3.5 text-muted-foreground" />
            <span>{truck.label}</span>
          </label>
        ))}
      </RadioGroup>
    </fieldset>
  );
}
